<!------------------HOSTED------------------>
<div *ngIf="point" [ngClass]="{ 'save-icon-wrapper-right': right }" class="save-mobile-wrapper">
  <a *ngIf="!addedToTrip" (click)="addToTrip()" class="cnt-button-secondary w-button" data-cy="add-to-trip">
    Add to Trip
  </a>
  <a
    *ngIf="addedToTrip"
    (click)="removeFromTrip()"
    class="cnt-button-secondary inverted w-button"
    data-cy="remove-from-trip"
  >
    Remove from Trip
  </a>
  <a *ngIf="user?.id && !favorited" (click)="favorite()" class="cnt-button-secondary w-button" data-cy="save-listing-mobile">
    Save this property
  </a>
  <a *ngIf="!user?.id" (click)="openModalSave()" class="cnt-button-secondary w-button" data-cy="save-listing-mobile">
    Save this property
  </a>
  <a
    *ngIf="user?.id && favorited"
    (click)="unfavorite()"
    class="cnt-button-secondary inverted w-button"
    data-cy="forget-listing-mobile"
  >
    Forget this property
  </a>
</div>
<!------------------BOONDOCK------------------>
<div
  *ngIf="boondockPoint || poi"
  [ngClass]="{ module: poi, 'save-icon-wrapper-right': right }"
  class="save-mobile-wrapper"
>
  <a *ngIf="!addedToTrip" (click)="addToTrip()" class="cnt-button-secondary w-button" data-cy="add-to-trip">
    Add To Trip
  </a>
  <a
    *ngIf="addedToTrip"
    (click)="removeFromTrip()"
    class="cnt-button-secondary inverted w-button"
    data-cy="remove-from-trip"
  >
    Remove From Trip
  </a>
  <a *ngIf="user?.id && !favorited" (click)="favorite()" class="cnt-button-secondary w-button" data-cy="save-listing-mobile">
    Save this property
  </a>
  <a *ngIf="!user?.id" (click)="openModalSave()" class="cnt-button-secondary w-button" data-cy="save-listing-mobile">
    Save this property
  </a>
  <a
    *ngIf="user?.id && favorited"
    (click)="unfavorite()"
    class="cnt-button-secondary inverted w-button"
    data-cy="forget-listing-mobile"
  >
    Forget this property
  </a>
  <a *ngIf="!user?.id" (click)="openModalRate()" class="cnt-button-secondary w-button" data-cy="rate-listing">
    Rate this property
  </a>
  <a *ngIf="user?.id" (click)="rate()" class="cnt-button-secondary w-button" data-cy="rate-listing">
    Rate this property
  </a>
  <a *ngIf="!point" (click)="navigate()" class="cnt-button-secondary w-button" data-cy="get-directions">
    Get directions
  </a>
  <a *ngIf="!user?.id" (click)="openModalDonate()" class="cnt-button-secondary w-button" data-cy="donate-btn">
    Donate
  </a>
  <a *ngIf="user?.id" (click)="donate()" class="cnt-button-secondary w-button" data-cy="donate-btn"> Donate </a>
</div>
